var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100" }, [
    _c(
      "div",
      { staticClass: "p-2 d-flex" },
      [
        _c(
          "v-col",
          { staticClass: "graph-container", attrs: { cols: "12", lg: "8" } },
          [
            _c("DateRangePicker", {
              staticClass: "mb-3",
              class: { "w-100": _vm.isMobile },
              attrs: {
                opens: "right",
                "append-to-body": true,
                "locale-data": _vm.localeData,
                ranges: _vm.customRange,
              },
              on: { update: _vm.updateDateRange },
              model: {
                value: _vm.dateRange,
                callback: function ($$v) {
                  _vm.dateRange = $$v
                },
                expression: "dateRange",
              },
            }),
            _vm._v(" "),
            _vm.data.datasets.length > 0
              ? _c("ChartLine", {
                  staticClass: "line-chart-container",
                  attrs: {
                    width: 800,
                    height: _vm.isMobile ? 800 : 340,
                    data: _vm.data,
                    chartOptions: _vm.chartOptions,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.userTrackingData
          ? _c("v-col", { attrs: { cols: "12", lg: "4" } }, [
              _c(
                "div",
                { staticClass: "d-flex", attrs: { "no-gutters": "" } },
                [
                  _vm.bannerHtml
                    ? [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.bannerHtml) },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { staticClass: "p-1", attrs: { cols: 6 } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "mx-auto p-1" },
                        [
                          _c("v-card-text", [
                            _c(
                              "div",
                              [
                                _vm._v(
                                  "\n                平均学習時間\n                "
                                ),
                                _c(
                                  "v-tooltip",
                                  {
                                    staticClass: "ms-2",
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        dark: "",
                                                      },
                                                    },
                                                    "v-icon",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    "\n                      mdi-comment-question-outline\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2642055890
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v("一日の平均学習時間になります。"),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "font-weight-black text-end" },
                              [
                                _c("h3", [
                                  _vm._v(_vm._s(_vm.averageTrackingTime)),
                                ]),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { staticClass: "p-1", attrs: { cols: 6 } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "mx-auto p-1" },
                        [
                          _c("v-card-text", [
                            _c(
                              "div",
                              [
                                _vm._v(
                                  "\n                平均学習完了数\n                "
                                ),
                                _c(
                                  "v-tooltip",
                                  {
                                    staticClass: "ms-2",
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        color: "primary",
                                                        dark: "",
                                                      },
                                                    },
                                                    "v-icon",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _vm._v(
                                                    "\n                      mdi-comment-question-outline\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2642055890
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "1日に完了した学習完了数の平均になります。"
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "font-weight-black text-end" },
                              [
                                _c("h3", [
                                  _vm._v(
                                    _vm._s(_vm.averageActivityCount) + " 個"
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              !_vm.isMobile
                ? _c(
                    "div",
                    { staticClass: "d-flex p-1" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: 12 } },
                        [
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.tableData,
                              "items-per-page": 5,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }